var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CART ICON") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "APU-109-Aspire-Sequence",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-Check-Out-/-Address",
    transform: "translate(-1155.000000, -230.000000)",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CART-ICON",
    transform: "translate(1155.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "6.17625 6.8688 20.2340698 6.8688 20.2340698 5.60564211 6.17625 5.60564211"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "0.477 -0.000126315789 0.000125 1.16766316 4.28575 2.9544 7.52825 14.7156632 21.69075 14.7156632 24.872 5.60576842 20.181375 5.60576842 20.181375 6.86955789 23.105125 6.86955789 20.80575 13.4525053 8.47825 13.4525053 5.32575 2.02218947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1154375,20.5422316 C8.5948125,20.5422316 8.1716875,20.9704421 8.1716875,21.4971789 C8.1716875,22.0239158 8.5948125,22.4521263 9.1154375,22.4521263 C9.6366875,22.4521263 10.0610625,22.0239158 10.0610625,21.4971789 C10.0610625,20.9704421 9.6366875,20.5422316 9.1154375,20.5422316 M9.1154375,23.7152842 C7.9054375,23.7152842 6.9216875,22.7205474 6.9216875,21.4971789 C6.9216875,20.2738105 7.9054375,19.2790737 9.1154375,19.2790737 C10.3260625,19.2790737 11.3110625,20.2738105 11.3110625,21.4971789 C11.3110625,22.7205474 10.3260625,23.7152842 9.1154375,23.7152842",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.13425,20.5422316 C19.613625,20.5422316 19.189875,20.9704421 19.189875,21.4971789 C19.189875,22.0239158 19.613625,22.4521263 20.13425,22.4521263 C20.6555,22.4521263 21.07925,22.0239158 21.07925,21.4971789 C21.07925,20.9704421 20.6555,20.5422316 20.13425,20.5422316 M20.13425,23.7152842 C18.92425,23.7152842 17.939875,22.7205474 17.939875,21.4971789 C17.939875,20.2738105 18.92425,19.2790737 20.13425,19.2790737 C21.344875,19.2790737 22.32925,20.2738105 22.32925,21.4971789 C22.32925,22.7205474 21.344875,23.7152842 20.13425,23.7152842",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "20.3345 17.9458737 8.445125 17.9458737 7.402625 14.2574526 8.603875 13.9107158 9.38825 16.6827158 20.3345 16.6827158"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.0f2dfd1387963d140f41a1ba5a243bff.svg";
export { ForwardRef as ReactComponent };